let increment = () => {};
let decrement = () => {};

export function registerGlobalLoader(handlers) {
  increment = typeof handlers?.increment === "function" ? handlers.increment : () => {};
  decrement = typeof handlers?.decrement === "function" ? handlers.decrement : () => {};
}

export function loaderIncrement() {
  increment();
}

export function loaderDecrement() {
  decrement();
}

